<template>
    <div class="page" id="playerBookChooseType">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Lesson Booking</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <!-- <span
                class="info mb10"
                style="background: #15f29f"
                v-if="user.type == 'player'"
            >
                Your Golf Pro has selected
                <strong>{{ lesson_duration }} minutes</strong> as their
                preferred lesson duration, please select this option unless
                otherwise instructed.
            </span> -->

            <form class="form3" @submit.prevent="submitForm">
                <div class="select">
                    <select
                        class="button dark"
                        v-model="form.type"
                        @change="submitForm"
                        :class="{ complete: form.type }"
                    >
                        <option value="">Select Lesson Type</option>
                        <option value="in_person">Face to Face</option>
                        <option value="video">Video</option>
                    </select>
                    <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
                </div>

                <has-error class="info error" :form="form" field="duration" />
            </form>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form, HasError } from "vform";
export default {
    name: "book",
    components: {
        FadeImage,
        XIcon,
        HasError,
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        lesson_duration() {
            if (this.user.type == "pro") {
                return this.user.settings.lesson_duration;
            } else {
                return this.user.lesson_settings.lesson_duration;
            }
        },
    },
    created() {},
    data() {
        return {
            form: new Form({
                type: "",
            }),
        };
    },
    methods: {
        submitForm() {
            if (this.form.type === "in_person") {
                this.$router.push({ name: "BookLesson" });
            } else {
                this.$router.push({ name: "BookVideoLesson" });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#playerBookChooseType {
    .button {
        margin-bottom: 10px;
        &.complete {
            background: white;
            color: $green_0;
        }
        .arrow {
            position: absolute;
            right: 20px;
            top: 20px;
        }
    }

    p {
        line-height: 1.5;
        color: $green_0;
    }
    .select {
        .arrow {
            position: absolute;
            right: 20px;
            top: 20px;
        }
        .button {
            padding-left: 17px !important;
        }
    }
    p {
        font-weight: 200;
        font-size: 14px;
    }
}
</style>
